import { Group, Text, useMantineTheme, rem, Center, Stack, Button, LoadingOverlay, Box } from '@mantine/core';
import { IconUpload, IconPhoto, IconX, IconFileSpreadsheet, IconFileUpload } from '@tabler/icons-react';
import { Dropzone, DropzoneProps, MS_EXCEL_MIME_TYPE } from '@mantine/dropzone';
import { useState } from 'react';

const FileDrop = ({ onDrop = () => {}, onReject = () => {}, onUpload = async () => {}, ...props }) => {
  const theme = useMantineTheme();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClickUpload = async () => {
    setLoading(true);
    
    await onUpload(file);

    setTimeout(() => {
      setFile(null)
      setLoading(false);
    }, 2000);
  }

  return (
    <Box mx='auto'>
      <LoadingOverlay visible={loading} overlayBlur={2} />
      <Dropzone
        onDrop={(files) => {
          console.log('accepted files', files)
          onDrop(files);
          setFile(files[0]);
        }}
        onReject={(files) => {
          console.log('rejected files', files)
          onReject(files);
        }}
        maxSize={3 * 1024 ** 2}
        maxFiles={1}
        multiple={false}
        accept={MS_EXCEL_MIME_TYPE}
        {...props}
      >
        <Group position="center" spacing="xl" style={{ minHeight: rem(220), pointerEvents: 'none' }}>
          <Dropzone.Accept>
            <IconUpload
              size="3.2rem"
              stroke={1.5}
              color={theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6]}
            />
          </Dropzone.Accept>
          <Dropzone.Reject>
            <IconX
              size="3.2rem"
              stroke={1.5}
              color={theme.colors.red[theme.colorScheme === 'dark' ? 4 : 6]}
            />
          </Dropzone.Reject>
          <Dropzone.Idle>
            <IconPhoto size="3.2rem" stroke={1.5} />
          </Dropzone.Idle>

          <div>
            <Text size="xl" inline>
              Drag files here
            </Text>
            <Text size="sm" color="dimmed" inline mt={7}>
              Allowed file type is the OBRC Container Registration Template
            </Text>
          </div>
        </Group>
      </Dropzone>
      {
        file && (
          <Center mt={25}>
            <Stack position='center' spacing='xs' align='center' maw={200}>
              <IconFileSpreadsheet size={50} />
              <Text fz={12} color='red' fw={500} ta='center'>{file.name}</Text>
              <Button mt={25} onClick={handleClickUpload}><IconFileUpload size={15} /> Upload</Button>
            </Stack>
          </Center>
        )
      }
    </Box>
  );
}

export default FileDrop;